// extracted by mini-css-extract-plugin
module.exports = {"list":"TextList_list__MPQYU"};